import {
  mergeDeepWith,
  pick,
  keys,
  mapObjIndexed,
  map,
  when,
  pipe,
  zip,
  apply,
  merge,
} from 'ramda';

import { isObject } from '../../../../../utilities/typeChecking';
import { commonInitialValues, legalEntityInitialValues, naturalPersonInitialValues } from './initialValues';
import { ENTRY_TYPE } from '../../../constants/watchListEntryConstants';

const getCommonPropertiesFromInitialState = from => pipe(
  pick(keys(from)),
  mapObjIndexed((val, key) => (Array.isArray(val)
    ? map(when(isObject, getCommonPropertiesFromInitialState(from[key][0])), val)
    : when(isObject, getCommonPropertiesFromInitialState(from[key]), val))),
);

export const selectInitialState = (prevInitialState, isLegalEntity) => {
  if (isLegalEntity === (prevInitialState && prevInitialState.type === ENTRY_TYPE.LEGAL_ENTITY)) {
    return prevInitialState;
  }

  const commonProperties = !prevInitialState
    ? commonInitialValues
    : getCommonPropertiesFromInitialState(commonInitialValues)(prevInitialState);

  const merged = mergeDeepWith(pipe(zip, map(apply(merge))),
    commonProperties,
    isLegalEntity
      ? legalEntityInitialValues
      : naturalPersonInitialValues);

  merged.type = isLegalEntity ? ENTRY_TYPE.LEGAL_ENTITY : ENTRY_TYPE.NATURAL_PERSON;

  return merged;
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upsert-watch-list-entry-form/initial-values/selectInitialState.js